module.exports = __webpack_public_path__ + "static/img/服务商_画板 1.0038d66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/服务商_画板 1.jpg
// module id = 01pH
// module chunks = 1